import {FC} from 'react'
import {DateRow} from 'components/SearchForm/DateRow'

export const RetiredAt: FC = () => {
  return <DateRow header="退職日" startName="retiredAtStart" endName="retiredAtEnd" />
}
